import React, { forwardRef } from 'react'

import { twMerge } from 'tailwind-merge'

import ButtonBase, {
  type ButtonProps as ButtonBaseProps,
} from '@/components/common/Button'

interface ButtonProps extends ButtonBaseProps {
  children: React.ReactNode
  type?: 'button' | 'submit' | 'reset'
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, className, type = 'button', ...props }, ref) => {
    return (
      <ButtonBase
        // @ts-ignore
        ref={ref}
        variant="soft-compact"
        className={twMerge(
          'h-6 px-1 shadow-sm text-[13px] text-primary-700 dark:text-primary-300 active:scale-100',
          className,
        )}
        type={type}
        {...props}
      >
        {children}
      </ButtonBase>
    )
  },
)

Button.displayName = 'ComboboxV2.Button'
